export const DialogType = {
  ADD_NOTE: 'addNote',
  VIEW_NOTE: 'viewNote',
  VERIFICATION_FORM_IS_DIRTY: 'verificationFormIsDirty',
  OPT_OUT_TEXT_MESSAGE_MODAL: 'optOutTextMessageModal',
  ACCOUNT_INFO_MODAL: 'accountInfoModal',
  GENERIC_ERROR: 'generic',
  SMS_PREFERENCE_UPDATE_FAILED_ERROR: 'smsPreferenceUpdateFailed',
  PACKAGE_PREVIEW_UNAVAILABLE_ERROR: 'packagePreviewUnavailable',
  PACKAGE_DOWNLOAD_FAILED_ERROR: 'packageDownloadFailed',
  OPT_OUT_SMS_FAILED_ERROR: 'optOutSmsFailed',
  VERIFY_INFO_SAVE_FAILED_ERROR: 'verifyInfoSaveFailed',
} as const

export type DialogType = (typeof DialogType)[keyof typeof DialogType]
